import { initializeApp } from "firebase/app";
const firebaseStagingConfig = require(process.env.REACT_APP_FIREBASE_PATH as string);

let config = firebaseStagingConfig;
const app = initializeApp(config);

export const useFirebaseClient = () => {
  return app;
};
